// NPM Dependencies
import moment, { Moment } from 'moment-timezone';

import ENUMS from 'common/dist/enums';
import { get } from 'lodash';


export class CityTzMapperService {

  public getCityTimezone = (city) => {
    const leadCity = ENUMS.acceptableUserCities.find(_city => _city.value === city);
    return get(leadCity, 'timezone');
  }

  public getCityTZmappedDate = ({ city, date }: { city: string, date: Date | string }) => {
    const tz = this.getCityTimezone(city);
    if (!tz) {
      // If timezone not found, Avoid storing tz (T00:00:00.000+00:00)
      return moment(date).format('YYYY-MM-DD');
    }
    return moment.tz(date, tz);
  }

  /**
   * Converts a UTC date to the local time of a specified city.
   * Useful for displaying date and time accurately in the user's or event's local timezone.
   *
   * @param date - The UTC date to convert (string, number, Date, or Moment).
   * @param city - The target city used to determine the timezone.
   * @param format - Optional Moment.js format string for formatted output.
   * @returns A formatted date string if `format` is provided, otherwise a Moment object.
   */
  public convertUtcToCityTz = ({
    date,
    city,
    format,
  }: {
    date: string | number | Date | Moment;
    city: string;
    format?: string;
  }): Moment | string => {
    const tz = this.getCityTimezone(city);

    if (!tz) {
      // If timezone not found, Do not convert to tz
      return format
        ? moment.utc(date).format(format)
        : moment.utc(date);
    }
    // Convert UTC -> specific timezone
    const tzMoment = moment.utc(date).tz(tz);
    return format
      ? tzMoment.format(format)
      : tzMoment;
  }
}
